import { Component, computed, input } from '@angular/core';
import { QuestionBase } from '@jump-tech-frontend/domain';
import { JuiAlertBlock } from '@jump-tech-frontend/core-components-angular';

import { I18nKeys } from '@jump-tech-frontend/app-config';
import { getCommonsTranslation } from '../utils/question-utils';

@Component({
  selector: 'question-hint',
  template: `
    @if (question().hint && question().permanentHint) {
      <div>
        <jui-alert-block size="md" color="low" [iconName]="icon()">
          <span [innerHtml]="renderHint()"></span>
        </jui-alert-block>
      </div>
    }
    `,
  imports: [JuiAlertBlock]
})
export class QuestionHintComponent {
  question = input.required<QuestionBase<string>>();
  i18ns = input<I18nKeys>();
  icon = computed(() => this.question().icon || 'info');

  renderHint = computed(() => {
    if (this.question().useI18ns && this.i18ns()) {
      const key = this.question().hint as string as keyof I18nKeys;
      const hint = getCommonsTranslation(this.i18ns(), key);
      return hint;
    } else {
      return this.question().hint;
    }
  });
}
